export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    PROFILE: '/auth/profile',
    RESUME: '/auth/resume',
    PROFILE_PICTURE: '/auth/profile-picture',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh-token',
    VERIFY_EMAIL: '/auth/verify-email',
    RESET_PASSWORD: '/auth/reset-password',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESEND_VERIFICATION: '/auth/resend-verification',
  },
  USERS: {
    GET_ALL: '/users',
    GET_BY_ID: (id: string) => `/users/${id}`,
    CREATE: '/users',
    UPDATE: (id: string) => `/users/${id}`,
    DELETE: (id: string) => `/users/${id}`,
  },
  STUDENTS: {
    GET_ALL: '/students',
    GET_BY_ID: (id: string) => `/students/${id}`,
    CREATE: '/students',
    UPDATE: (id: string) => `/students/${id}`,
    DELETE: (id: string) => `/students/${id}`,
  },
  STAFF: {
    GET_ALL: '/staff',
    GET_BY_ID: (id: string) => `/staff/${id}`,
    CREATE: '/staff',
    UPDATE: (id: string) => `/staff/${id}`,
    DELETE: (id: string) => `/staff/${id}`,
  },
  PARENTS: {
    GET_ALL: '/parents',
    GET_BY_ID: (id: string) => `/parents/${id}`,
    CREATE: '/parents',
    UPDATE: (id: string) => `/parents/${id}`,
    DELETE: (id: string) => `/parents/${id}`,
  },
  FILES: {
    UPLOAD: '/files/upload',
    DELETE: (id: string) => `/files/${id}`,
    DOWNLOAD: (id: string) => `/files/download/${id}`,
  },
  UPLOAD: {
    SINGLE: '/upload/single',
    MULTIPLE: '/upload/multiple',
    DELETE_FILE: (id: string) => `/upload/${id}`,
  },
  DESIGNATIONS: {
    GET_ALL: '/designations',
  },
  FEED: {
    FEED_TYPES: '/feedtypes',
    FEEDS: '/feeds',
    MY_FEEDS: '/feeds/my-feeds',
    CREATE_FEED: '/feeds',
    DELETE_FEED: (feedId: string) => `/feeds/${feedId}`,
    APPLY: '/apply',
    REPORT: '/reports',
    VOTE_POLL: (feedId: string) => `/feeds/${feedId}/poll/vote`,
    SUPER_ADMIN_TOP_5: '/feeds/super-admin/top-5',
    POSTS_WITH_DOCUMENTS: '/feeds/posts-with-documents',
  },
  NEWS: {
    TOP_5: '/news/top-5',
    ALL: '/news',
    DETAIL: (id: string) => `/news/${id}`,
    CREATE: '/news'
  },
  LIKES: {
    TOGGLE: '/likes/toggle',
    GET_BY_FEED: (feedId: string) => `/likes/feed/${feedId}`,
  },
  COMMENTS: {
    CREATE: '/comments',
    UPDATE: (commentId: string) => `/comments/${commentId}`,
    DELETE: (commentId: string) => `/comments/${commentId}`,
    GET_BY_FEED: (feedId: string) => `/comments/feed/${feedId}`,
  },
  FOLLOW: {
    SUGGESTIONS: '/follow/suggestions',
    SEARCH: '/follow/search',
    REQUEST: '/follow/request',
    REQUESTS: '/follow/requests',
    RESPOND: (id: string) => `/follow/request/${id}/respond`,
    CANCEL_REQUEST: '/follow/request/cancel',
    UNFOLLOW: '/follow/unfollow',
    FOLLOWERS: (userId: string) => `/follow/followers/${userId}`,
    FOLLOWING: (userId: string) => `/follow/following/${userId}`,
  },
  EVENTS: {
    GET_ALL: '/conference-events',
    MY_EVENTS: '/conference-events/my-events',
    GET_BY_ID: (id: string) => `/conference-events/${id}`,
    CREATE: '/conference-events',
    UPDATE: (id: string) => `/conference-events/${id}`,
    DELETE: (id: string) => `/conference-events/${id}`,
    ENROLL: (id: string) => `/conference-events/${id}/enroll`,
    MARK_INACTIVE: (id: string) => `/conference-events/${id}/mark-inactive`,
    ENROLLED_USERS: (id: string) => `/conference-events/${id}/enrolled-users`,
    ENROLLED_USERS_EXPORT: (id: string) => `/conference-events/${id}/enrolled-users/export`,
    REPORT: (id: string) => `/conference-events/${id}/report`,
    REPORTS: '/conference-events/reports',
  },
  ADMIN: {
    USERS: '/admin/users',
    USERS_EXPORT: '/admin/users/export',
    USER_BY_ID: (id: string) => `/admin/users/${id}`,
    BLOCK_USER: (id: string) => `/admin/users/${id}/block`,
    UNBLOCK_USER: (id: string) => `/admin/users/${id}/unblock`,
    FOLDERS: '/folders',
    FOLDER_BY_ID: (id: string) => `/folders/${id}`,
    LINKS: '/links',
    LINK_BY_ID: (id: string) => `/links/${id}`,
  },
  SERVICE_PRODUCTS: {
    GET_ALL: '/service-products',
    GET_BY_ID: (id: string) => `/service-products/${id}`,
    CREATE: '/service-products',
    UPDATE: (id: string) => `/service-products/${id}`,
    DELETE: (id: string) => `/service-products/${id}`,
    REPORT: (id: string) => `/service-products/${id}/report`,
    REPORTS: '/service-products/reports',
  },
  BUSINESS_COURSES: {
    GET_ALL: '/business-courses',
    GET_PUBLIC: '/business-courses/public',
    GET_PUBLIC_BY_ID: (id: string) => `/business-courses/public/${id}`,
    SITEMAP: '/business-courses/sitemap',
    MY_ITEMS: '/business-courses/my-items',
    GET_BY_ID: (id: string) => `/business-courses/${id}`,
    CREATE: '/business-courses',
    UPDATE: (id: string) => `/business-courses/${id}`,
    DELETE: (id: string) => `/business-courses/${id}`,
    REPORT: (id: string) => `/business-courses/${id}/report`,
    REPORTS: '/business-courses/reports',
  },
  ENQUIRIES: {
    TRACK: '/enquiries',
    MY_LEADS: '/enquiries/my-leads',
    EXPORT: '/enquiries/export',
    GET_BY_ID: (id: string) => `/enquiries/${id}`,
    UPDATE_STATUS: (id: string) => `/enquiries/${id}/status`,
    ADD_COMMENT: (id: string) => `/enquiries/${id}/comments`,
  },
  COURSE_LEADS: {
    TRACK: '/course-leads',
    MY_LEADS: '/course-leads/my-leads',
    EXPORT: '/course-leads/export',
    GET_BY_ID: (id: string) => `/course-leads/${id}`,
    UPDATE_STATUS: (id: string) => `/course-leads/${id}/status`,
    ADD_COMMENT: (id: string) => `/course-leads/${id}/comments`,
  },
} as const;